import{useState as t}from"react";const o=(o,r)=>{const e=void 0!==r,[a,c]=t(o);return[e?r:a,t=>{e||c(t)}]};export{o as default};
